module.exports = __webpack_public_path__ + "img/thumbnail_HamadryasBaboon_j_normal.4f7b69fe.png";